// extracted by mini-css-extract-plugin
export default {"CardHomeShopping":"Shopping_CardHomeShopping__KxqGS","shoppingTitle":"Shopping_shoppingTitle__DCjbW","NADefaults":"Shopping_NADefaults__iVg-K"};